module.exports = __webpack_public_path__ + "media/customizations/viridian/back-1ce857e6b21445b1641f201a3200641b.jpg";